import { Users, Store, Inbox, Download } from "lucide-react";
import { downloadCsv } from "./bits";

const ExportCard = ({ testId, icon: Icon, title, desc, path, file, disabled, disabledNote }) => (
  <div className="card-dark p-6 hover:transform-none sm:p-8" data-testid={testId}>
    <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#1E3A8A]/40 bg-[#1E3A8A]/10">
      <Icon size={16} className="text-[#1E3A8A]" />
    </span>
    <h3 className="mt-5 font-sans text-xl text-[#0F172A]">{title}</h3>
    <p className="mt-2 text-sm leading-relaxed text-[#94A3B8]">{desc}</p>
    {disabled ? (
      <p className="mt-5 rounded-lg border border-[#1E3A8A]/30 bg-[#1E3A8A]/5 px-4 py-3 text-xs leading-relaxed text-[#64748B]" data-testid={`${testId}-disabled-note`}>
        {disabledNote}
      </p>
    ) : (
      <button onClick={() => downloadCsv(path, file)} data-testid={`${testId}-button`} className="btn-gold mt-5 !px-6 !py-2.5 !text-xs">
        <Download size={14} /> Download CSV
      </button>
    )}
  </div>
);

export const ExportsView = ({ summary }) => {
  const sheetsReady = Boolean(summary && summary.sheets_connected);
  const sheetsNote = "Connect Google Sheets first — buyer and vendor records live in your Google tracker sheets.";

  return (
    <div className="mt-12" data-testid="admin-exports-view">
      <p className="max-w-2xl text-sm leading-relaxed text-[#94A3B8]">
        Download your records as CSV spreadsheets — they open in Excel, Google Sheets or Numbers.
      </p>
      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        <ExportCard
          testId="export-buyers"
          icon={Users}
          title="Buyer Waitlist"
          desc="Every buyer early-access submission from your Google Forms tracker."
          path="/admin/export/buyers"
          file="aflimart-buyer-waitlist.csv"
          disabled={!sheetsReady}
          disabledNote={sheetsNote}
        />
        <ExportCard
          testId="export-vendors"
          icon={Store}
          title="Vendor Applications"
          desc="Every vendor and business application from your Google Forms tracker."
          path="/admin/export/vendors"
          file="aflimart-vendor-applications.csv"
          disabled={!sheetsReady}
          disabledNote={sheetsNote}
        />
        <ExportCard
          testId="export-enquiries"
          icon={Inbox}
          title="Contact Enquiries"
          desc="Every message sent through the website contact form."
          path="/admin/export/enquiries"
          file="aflimart-contact-enquiries.csv"
          disabled={false}
        />
      </div>
    </div>
  );
};
